import * as Yup from 'yup';

export default () => {
  return Yup.object().shape({
    status: Yup.string().required('Field is required'),
  });
};
